import React from "react";
import { Modal } from "antd";

export const TinyModal = ({ open, title = "", width, height, centered, onClose, children }) => {

  return (
    <Modal
      title={title}
      open={open}
      width={width}
      closable={true}
      centered
      styles={{    
        header: {
          paddingInlineStart: 22,
          display: 'flex',
          alignItems: 'center',
          height: '60px',
          borderBottom: '1px solid var(--color-gray08)',
        },
        title: {

        },
        content: {
          padding: '0px 0px 22px 0px',
        },
        body: {
          padding: '22px',
          overflowY: 'auto',
          height
        }
      }}
      footer={[]}
      onCancel={onClose}
    >
      {children}
    </Modal>
  );
};
